import React, { useEffect, useState } from "react";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import BXPDetails from "../PackagedServices/BXPDetails";
import PricingTerms from "../PackagedServices/PricingTerms";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import PackagedServiceList from "../ALLOTSProductsLists/PackagedServiceList";
import {
  deleteOTS,
  getMineBXPOTSList,
  getOTSById,
} from "../../../../redux/ots/action";
import {
  getPenalty,
} from "../../../../redux/categary/action";
import Access from "../../../CustomComponents/Access/Access";
import ImportantNoteOTS from "../../../Common/ImportantNote/ImportantNoteOTS";
import BXPWorkSamples from "../PackagedServices/BXPWorkSamples";
import { useLocation } from "react-router-dom";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import { useTranslation } from "react-i18next";
import TranslatedText from "../../../Common/TranslatedText";
import CloseConfirmModal from "../../../Common/CloseConfirmModal";
import useConfirmRefresh from "../../../../utils/useConfirmRefresh";
import CommissionNote from "../../../Common/ImportantNote/CommissionNote";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function PackagedService({ autoOpen }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const [activeTab, setActiveTab] = useState("BXPDetails");
  const [modalOpen, setModalOpen] = useState(false);
  const [updateindex, setUpdateindex] = useState(null);
  const [bxpData, setbxpData] = useState("");
  const [modal, setModal] = useState(false);
  const [changesIsThere, setChangesIsThere] = useState(false);
  const [showDraftModal, setShowDraftModal] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const packageId = queryParams.get("packageid");

  const closeModal = () => {
    setModalOpen(false);
    setModal(false);
  };

  const modalStyle = {
    right: modalOpen ? "0" : "-100%",
  };
  useEffect(() => {
    scrollToTop();
  }, [activeTab]);


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const dispatch = useDispatch();
  const getmineotslist = useSelector(
    ({ ots: { getmineotslist } }) => getmineotslist
  );
  const getotsbyid = useSelector(({ ots: { getotsbyid } }) => getotsbyid);


  useEffect(() => {
    dispatch(getMineBXPOTSList());
    dispatch(getPenalty());
  }, []);

  const { setOTSAutoOpen } = useRouteBaseStateContext();

  useEffect(() => {
    if (autoOpen) {
      checkaccessss();
      setOTSAutoOpen(false);
    }
  }, [autoOpen]);

  useEffect(() => {
    const isNotEmpty = getotsbyid && Object.keys(getotsbyid).length > 0;
    if (updateindex !== null) {
      if (isNotEmpty) {
        setbxpData(getotsbyid);
      } else {
        setbxpData("");
      }
    }
  }, [getotsbyid, updateindex]);

  const getBXPDATA = (id) => {
    dispatch(getOTSById(id));
  };
  const updateBxp = (index) => {
    setUpdateindex(index);
    getBXPDATA(index);
    setModalOpen(true);
    setActiveTab("BXPDetails");
  };

  useEffect(() => {
    packageId && updateBxp(packageId);
  }, [packageId]);

  const deleteee = (id) => {
    dispatch(deleteOTS(id, setLoading));
  };

  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [modalOpen]);

  const openmodel = () => {
    const draft = localStorage.getItem("OTS_ADD_DRAFT");
    if (draft) {
      setShowDraftModal(true);
    } else {
      setModalOpen(true);
      setbxpData("");
      setActiveTab("BXPDetails");
      setUpdateindex(null);
    }
  };

  const handleConfirmDraft = () => {
    const draft = localStorage.getItem("OTS_ADD_DRAFT");
    if (draft) {
      setbxpData(JSON.parse(draft));
    }
    setModalOpen(true);
    setActiveTab("BXPDetails");
    setUpdateindex(null);
    setShowDraftModal(false);
  };

  const handleCancelDraft = () => {
    localStorage.removeItem("OTS_ADD_DRAFT");
    setModalOpen(true);
    setbxpData("");
    setActiveTab("BXPDetails");
    setUpdateindex(null);
    setShowDraftModal(false);
  };

  useEffect(() => {
    if (modalOpen && updateindex === null && bxpData && Object.keys(bxpData).length > 0) {
      localStorage.setItem("OTS_ADD_DRAFT", JSON.stringify(bxpData));
    }
  }, [bxpData, updateindex, modalOpen]);

  const checkaccessss = () => {
    setModal(true);
  };

  useConfirmRefresh(modalOpen ? true : false);

  return (
    <>
      <ConfirmModal
        isOpen={showDraftModal}
        toggle={() => setShowDraftModal(!showDraftModal)}
        title="Continue last edit?"
        message="Would you like to continue last edit?"
        onConfirm={handleConfirmDraft}
        onCancel={handleCancelDraft}
        confirmText="Yes"
        cancelText="No"
      />
      <div>
        {modal ? (
          <Access
            modal={modal}
            setModal={setModal}
            state={"state"}
            checkpermission={"create_bxp"}
            hitmethod={() => { openmodel() }}
            checkrole={true}
          />
        ) : (
          ""
        )}
        <div
          className={
            modalOpen
              ? `add-education-modal add-overlay-modal-width active add-bxp-modal active`
              : "add-education-modal add-overlay-modal-width active add-bxp-modal"
          }
          style={modalStyle}
        >

          <div className={`modal-overlay-sec   ${modalOpen ? 'active' : ''}`}></div>
          <div className="modal-width">
            <div className="modal-head">
              <h3> {updateindex !== null ? "Edit" : "Add"} <TranslatedText i18nKey="OTS1" /></h3>
              <CloseConfirmModal closeModal={closeModal} type={updateindex != null ? "Edit" : "Add"} changesIsThere={updateindex ? true : activeTab != "BXPDetails" ? true : changesIsThere} />
            </div>
            <CommissionNote type={'create_bxp'} item={<TranslatedText i18nKey="OTS1" />} />

            {<div className="tab-bxp">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={
                      activeTab == "BXPDetails"
                        ? "active"
                        : activeTab == "WorkSamples"
                          ? "active"
                          : activeTab == "PricingTerms"
                            ? "active"
                            : ""
                    }
                  >
                    <span>1</span> Service Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      activeTab == "WorkSamples"
                        ? "active"
                        : activeTab == "PricingTerms"
                          ? "active"
                          : ""
                    }
                  >
                    <span>2</span> Work Samples
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    // onClick={() => setActiveTab("PricingTerms")}
                    className={activeTab == "PricingTerms" ? "active" : ""}
                  >
                    <span>3</span> Pricing & Terms
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="BXPDetails">
                  <BXPDetails
                    updateindex={updateindex}
                    bxpData={bxpData}
                    setbxpData={setbxpData}
                    setActiveTab={setActiveTab}
                    key={modalOpen ? updateindex ?? "add" : "closed"}
                    setChangesIsThere={setChangesIsThere}
                  />
                </TabPane>
                <TabPane tabId="WorkSamples">
                  <BXPWorkSamples
                    updateindex={updateindex}
                    bxpData={bxpData}
                    setbxpData={setbxpData}
                    setActiveTab={setActiveTab}
                    key={modalOpen ? updateindex ?? "add" : "closed"}
                  />
                </TabPane>
                <TabPane tabId="PricingTerms">
                  <PricingTerms
                    updateindex={updateindex}
                    bxpData={bxpData}
                    setbxpData={setbxpData}
                    setActiveTab={setActiveTab}
                    setFormData={setFormData}
                    setModalOpen={setModalOpen}
                    setModal={setModal}
                    key={modalOpen ? updateindex ?? "add" : "closed"}
                  />
                </TabPane>
              </TabContent>
            </div>}
          </div>
        </div>
      </div>


      <div className="packagedservice">
        <div className="packaged-first">
          <h4><TranslatedText i18nKey="OTS1" /></h4>
          <button
            className="buttons border-button"
            onClick={() => {
              checkaccessss();
            }}
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
              alt=""
            />
            Add
          </button>
        </div>
        {getmineotslist?.length > 0 ? <PackagedServiceList
          listing={getmineotslist}
          update={updateBxp}
          deleteee={deleteee}
        /> : <PostNotFound title={"No Post Found"} height={200} />}
      </div>

    </>
  );
}
